// extracted by mini-css-extract-plugin
export default {"component":"b2DgNy","text":"c2DgNy","brandedText":"d2DgNy","takeoverText":"e2DgNy","icon":"f2DgNy"};